import { DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import {
  FieldId,
  FieldValues,
  OutreachFormStatusList,
  TemplateDefinition,
} from '@upstart/harmony/lib/legos/outreachTypes';
import {
  ConfiguredTemplateDefinitions,
  FieldDefaults,
  FieldNames,
} from '@upstart/harmony/lib/legos/constants/outreach';
import { NotifyFormat } from '@upstart/harmony/lib/legos/constants';
import { OutreachFormListEntry } from '../containers/OutreachForms/types';

export interface FieldInfo {
  fieldId: FieldId;
  name: string;
  defaultValue: string | undefined;
}

export const getTemplateFieldListFromConfiguration = (
  templateId: NotifyFormat,
): FieldInfo[] => {
  const fieldDefaults: FieldValues = FieldDefaults[templateId] || {};

  return Object.values(
    ConfiguredTemplateDefinitions[templateId]?.fieldIds || [],
  ).map(
    (fieldId): FieldInfo => ({
      fieldId: fieldId as FieldId,
      name: FieldNames[fieldId] || 'Not configured',
      defaultValue: fieldDefaults[fieldId],
    }),
  );
};

export const getTemplateListAugmentedWithData = (
  dealerId: DealerId,
  outreachForms: OutreachFormStatusList,
): OutreachFormListEntry[] =>
  Object.keys(ConfiguredTemplateDefinitions).map((templateIdStr) => {
    const templateId: NotifyFormat = templateIdStr as NotifyFormat;

    const templateDef: TemplateDefinition | undefined =
      ConfiguredTemplateDefinitions[templateId];

    return {
      templateId,
      dealerId,
      name: templateDef?.name || 'Not configured',
      enabled: outreachForms[templateId]?.enabled ?? true,
    } as OutreachFormListEntry;
  });

export const getNameForOutreachFormTemplateId = (
  templateId: NotifyFormat,
): string =>
  ConfiguredTemplateDefinitions[templateId]?.name || templateId || 'None';
